import React, { useContext, useState } from 'react';
import { ShopContext } from '../Context/ShopContext';
import { useNavigate } from 'react-router-dom';
import './CSS/Checkout.css';

const Checkout = () => {
    const {
        getTotalCartAmount,
        all_product,
        cartItems,
        clearCart
    } = useContext(ShopContext);

    const navigate = useNavigate();


    const [formData, setFormData] = useState({
        fullName: '',
        email: '',
        phone: '',
        address: '',
        city: '',
        postalCode: '',
        country: ''
    });


    const [errors, setErrors] = useState({});

    const cartProducts = [];
    all_product.forEach((product) => {
        const sizes = cartItems[product.id];
        if (sizes) {
            Object.keys(sizes).forEach((size) => {
                const qty = sizes[size];
                if (qty > 0) {
                    cartProducts.push({ ...product, size, quantity: qty });
                }
            });
        }
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
        if (errors[name]) {
            setErrors(prev => ({ ...prev, [name]: '' }));
        }
    };

    const validateForm = () => {
        const newErrors = {};

        if (!formData.fullName.trim()) newErrors.fullName = 'Full Name is required';
        if (!formData.email.trim()) {
            newErrors.email = 'Email is required';
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            newErrors.email = 'Email is invalid';
        }
        if (!formData.phone.trim()) {
            newErrors.phone = 'Phone number is required';
        } else if (!/^01[0-2,5]{1}[0-9]{8}$/.test(formData.phone.replace(/\s/g, ''))) {
            newErrors.phone = 'Invalid Egyptian phone number (e.g. 01012345678)';
        }
        if (!formData.address.trim()) newErrors.address = 'Address is required';
        if (!formData.city.trim()) newErrors.city = 'City is required';
        if (!formData.postalCode.trim()) newErrors.postalCode = 'Postal Code is required';
        if (!formData.country) newErrors.country = 'Please select a country';

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validateForm()) {
            clearCart();

            navigate('/thank-you');
        }
    };

    return (
        <div className="checkout">
            <div className="checkout-container">
                <h1>Checkout</h1>

                <div className="checkout-content">
                    <div className="checkout-form">
                        <h2>Shipping Information</h2>
                        <form onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label>Full Name *</label>
                                <input
                                    type="text"
                                    name="fullName"
                                    value={formData.fullName}
                                    onChange={handleChange}
                                    className={errors.fullName ? 'error' : ''}
                                />
                                {errors.fullName && <span className="error-text">{errors.fullName}</span>}
                            </div>

                            <div className="form-group">
                                <label>Email *</label>
                                <input
                                    type="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    className={errors.email ? 'error' : ''}
                                />
                                {errors.email && <span className="error-text">{errors.email}</span>}
                            </div>

                            <div className="form-group">
                                <label>Phone Number *</label>
                                <input
                                    type="tel"
                                    name="phone"
                                    value={formData.phone}
                                    onChange={handleChange}
                                    placeholder="e.g. 01012345678"
                                    className={errors.phone ? 'error' : ''}
                                />
                                {errors.phone && <span className="error-text">{errors.phone}</span>}
                            </div>

                            <div className="form-group">
                                <label>Address *</label>
                                <input
                                    type="text"
                                    name="address"
                                    value={formData.address}
                                    onChange={handleChange}
                                    placeholder="Street address"
                                    className={errors.address ? 'error' : ''}
                                />
                                {errors.address && <span className="error-text">{errors.address}</span>}
                            </div>

                            <div className="form-row">
                                <div className="form-group">
                                    <label>City *</label>
                                    <input
                                        type="text"
                                        name="city"
                                        value={formData.city}
                                        onChange={handleChange}
                                        className={errors.city ? 'error' : ''}
                                    />
                                    {errors.city && <span className="error-text">{errors.city}</span>}
                                </div>
                                <div className="form-group">
                                    <label>Postal Code *</label>
                                    <input
                                        type="text"
                                        name="postalCode"
                                        value={formData.postalCode}
                                        onChange={handleChange}
                                        className={errors.postalCode ? 'error' : ''}
                                    />
                                    {errors.postalCode && <span className="error-text">{errors.postalCode}</span>}
                                </div>
                            </div>

                            <div className="form-group">
                                <label>Country *</label>
                                <select
                                    name="country"
                                    value={formData.country}
                                    onChange={handleChange}
                                    className={errors.country ? 'error' : ''}
                                >
                                    <option value="">Select Country</option>
                                    <option value="EG">Egypt</option>
                                    <option value="SA">Saudi Arabia</option>
                                    <option value="AE">United Arab Emirates</option>
                                    <option value="KW">Kuwait</option>
                                    <option value="QA">Qatar</option>
                                </select>
                                {errors.country && <span className="error-text">{errors.country}</span>}
                            </div>
                        </form>
                    </div>

                    <div className="checkout-summary">
                        <h2>Order Summary</h2>
                        <div className="summary-items">
                            {cartProducts.map((item) => (
                                <div key={`${item.id}-${item.size}`} className="summary-item">
                                    <img src={item.image} alt={item.name} />
                                    <div className="item-details">
                                        <p>{item.name}</p>
                                        <small>Size: {item.size} | Qty: {item.quantity}</small>
                                        <p className="price">${item.new_price * item.quantity}</p>
                                    </div>
                                </div>
                            ))}
                        </div>

                        <hr />

                        <div className="summary-total">
                            <div className="total-row">
                                <p>Subtotal</p>
                                <p>${getTotalCartAmount()}</p>
                            </div>
                            <div className="total-row">
                                <p>Shipping</p>
                                <p style={{ color: 'green' }}>Free</p>
                            </div>
                            <div className="total-row final">
                                <h3>Total</h3>
                                <h3>${getTotalCartAmount()}</h3>
                            </div>
                        </div>

                        <button type="submit" className="pay-button" onClick={handleSubmit}>
                            Pay Now
                        </button>
                        <button className="back-button" onClick={() => navigate('/cart')}>
                            Back to Cart
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Checkout;